import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfileService } from "@services/user-profile.service";

declare function openChatGamora(fila): any;

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  @Input() disableContactUs: boolean = false;

  constructor(private readonly router: Router, private readonly userProfileService: UserProfileService) { }

  ngOnInit() {
   this.setButtonsStates();
  }

  private setButtonsStates() {
    const isSelecionarPerfil = this.router.url === '/selecionar-perfil';
    const isPrivilegedUser = this.userProfileService.isBackOffice() || this.userProfileService.isPartner();

    if (this.disableContactUs) {
      return;
    }

    this.disableContactUs = isSelecionarPerfil || isPrivilegedUser;
  }
}
